import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    content: {
        width: "100%",
    },
    description: {
        marginTop: 24,
        display: "block",
        [theme.breakpoints.down("desktop")]: {
            fontSize: theme.fontSizes.md,
            marginTop: 8,
        },
    },
    tabsContainer: {
        marginTop: 28,
        [theme.breakpoints.down("desktop")]: {
            marginTop: 12,
        },
    },

    stepTwo_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
    },

    mobile_stepTwo_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        padding: "0px 20px",
    },

    title_container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "32px",
        marginBottom: "32px",
        width: "100%",
    },

    mobile_title_container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "32px",
        width: "100%",
        marginBottom: "20px",
    },

    underlineNav_container: {
        marginTop: "10px",
    },

    secondRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginBottom: "40px",
    },

    mobile_secondRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginBottom: "31px",
    },

    links: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "236px",
        marginTop: "17px",
    },

    graph_container: {
        width: "100%",
        minHeight: 200,
        marginBottom: "64px",
    },

    mobile_graph_container: {
        width: "100%",
        minHeight: 200,
        marginBottom: "30px",
    },

    wideTable_container: {
        width: "100%",
    },

    //---------------------------------- step 1 -------------------------

    stepOne_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
    },

    mobile_stepOne_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        padding: "0px 20px",
    },

    title_container_stepOne: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        marginBottom: "41px",
    },

    mobile_title_container_stepOne: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginBottom: "32px",
        width: "100%",
    },

    stepOne_firstRow: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
        gap: "41px",
        marginBottom: "56px",
    },

    mobile_stepOne_firstRow: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        gap: "24px",
        marginBottom: "24px",
        width: "100%",
    },

    stepOne_inputs_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
    },

    mobile_stepOne_inputs_container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "revert",
        alignItems: "center",
        height: "100%",
        gap: "32px",
        width: "100%",
        marginBottom: "24px",
    },

    stepOne_radioButtons_container: {},

    firstStep_tempRow: {},

    selectTempLabel: {
        color: "#353535",
        fontSize: "14px",
        letterSpacing: 0,
        marginBottom: "12px",
    },

    tempArray: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "7px",
        marginBottom: "40px",
    },

    calculateButton_container: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
        marginBottom: "32px",
    },

    inputWrapper: {
        width: 324,
    },
    mobile_inputWrapper: {
        width: "100%",
    },
}));

export default useStyles;
